// Healthcare API Configuration for HIPAA Compliance
// Integrates Firebase Auth with Google Healthcare API

export const healthcareConfig = {
  projectId: process.env.REACT_APP_GCP_PROJECT_ID || 'goatnote-ehr-dev-3799',
  location: 'us-central1',
  datasetId: 'demo-hospital-ehr',
  fhirStoreId: 'demo-patients',
  apiVersion: 'v1'
};

// Construct Healthcare API base URL
export const HEALTHCARE_API_BASE = `https://healthcare.googleapis.com/${healthcareConfig.apiVersion}/projects/${healthcareConfig.projectId}/locations/${healthcareConfig.location}/datasets/${healthcareConfig.datasetId}/fhirStores/${healthcareConfig.fhirStoreId}`;

// FHIR API endpoint for Cloud Run service
export const FHIR_API_BASE_URL = process.env.REACT_APP_FHIR_API_URL || 'https://goatnote-ehr-backend-233677712628.us-central1.run.app/fhir';

// HIPAA-compliant session configuration
export const sessionConfig = {
  timeoutMinutes: 15,
  warningMinutes: 2,
  checkIntervalSeconds: 60
};

// Audit log configuration
export const auditConfig = {
  enabled: process.env.REACT_APP_ENABLE_AUDIT_LOGGING !== 'false',
  endpoint: '/api/audit',
  includeUserAgent: true,
  includeTimestamp: true
};

// Role definitions for RBAC
export const userRoles = {
  PHYSICIAN: 'physician',
  NURSE: 'nurse',
  ADMIN: 'admin',
  VIEWER: 'viewer'
};

// Permission mappings
export const permissions = {
  [userRoles.PHYSICIAN]: [
    'patients.read',
    'patients.write',
    'patients.delete',
    'medications.prescribe',
    'labs.order',
    'notes.write'
  ],
  [userRoles.NURSE]: [
    'patients.read',
    'vitals.write',
    'medications.administer',
    'beds.manage',
    'notes.read'
  ],
  [userRoles.ADMIN]: [
    'audit.read',
    'users.manage',
    'system.configure',
    'reports.generate'
  ],
  [userRoles.VIEWER]: [
    'patients.read',
    'notes.read'
  ]
};

// Demo mode configuration
export const demoConfig = {
  enabled: process.env.REACT_APP_DEMO_MODE === 'true',
  mockPatientCount: 20,
  demoAccounts: {
    physician: 'doctor.demo@thegoatnote.com',
    nurse: 'nurse.demo@thegoatnote.com',
    admin: 'admin.demo@thegoatnote.com'
  }
}; 